// eslint-disable-next-line strict
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const routes = {
  home: '/',
  contactInfo: '/about-and-cotact',
  privacypolicy: '/privacy-policy',
  sitemap: '/sitemap',
  report: '/send-feedback',
  videos: '/videos',
  mods: '/mods',
  modsPaginate: '/mods/:pageNumber?',
  software: '/software',
  softwarePaginate: '/software/:pageNumber?',
  posts: {
    unit: '/post',
    list: '/posts',
    paginate: '/posts/:pageNumber?',
    view: '/post/:id',
  },
  news: {
    unit: '/report',
    list: '/news',
    paginate: '/news/:pageNumber?',
    view: '/report/:id',
  },
  tutorials: {
    unit: '/tutorial',
    list: '/tutorials',
    paginate: '/tutorials/:pageNumber?',
    view: '/tutorial/:id',
  },
  cancelSubs: '/cancel-subscription/:detachHash'
}

exports["default"] = routes;
module.exports = exports["default"];